import { useLocation } from '@thd-olt-component-react/router';
import React, { useEffect, useState } from 'react';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { CustomerAccountNavigation } from '@thd-olt-component-react/customer-account-navigation';
import { Heading } from '../Heading/Heading';

export const LeftNavigation = ({
  currentRouteName,
}: {
  currentRouteName: string;
}) => {
  // left nav was flashing on first render if refreshing a quote details page
  const [showLeftNav, setShowLeftNav] = useState(
    currentRouteName !== 'quote-details',
  );
  const location = useLocation();

  useEffect(() => {
    setShowLeftNav(!location.pathname.includes('quote/details/'));
  }, [location]);

  return (
    <>
      {showLeftNav && (
        <div className="sui-col-span-6 lg:sui-col-span-3">
          <Heading title="Job Quotes" />
          {/* hides the left nav automatically for screens < 1024px */}
          <QueryProvider cacheKey="left-nav">
            <CustomerAccountNavigation />
          </QueryProvider>
        </div>
      )}
    </>
  );
};
